export default __webpack_public_path__ + "static/media/photo--lg--alaina-1.35fdf259.jpg";